/* eslint-disable no-unused-vars */
export enum PersonalInfoActionType {
  GET_PERSONAL_INFO = 'get_personal_info',
  GET_PERSONAL_INFO_SUCCESS = 'get_personal_info_success',
  GET_PERSONAL_INFO_FAILURE = 'get_personal_info_failure',
  PATCH_PERSONAL_INFO_SUCCESS = 'patch_personal_info_success',
  PATCH_PERSONAL_INFO_FAILURE = 'patch_personal_info_failure',
}
